import { datahubPartial } from '@shared/partials/datahub.partial';
import { AverageQueryMeteredDataResultDto } from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { Columns } from '@shared/interfaces/table/column-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import { estimationMethodPartial } from '@shared/partials/estimationmethod.partial';
import { consumptiontypePartial } from '@shared/partials/consumptionType';

export const meteringPointTimeseriesTable: TableConfig<AverageQueryMeteredDataResultDto> = {
  id: 'meteringpoint-timeseries',
  selectable: false,
  pageSize: 100,
  exportable: true,
  copyable: true,
  oData: true,
  columns: [
    {
      title: 'meteringPoint.timeSeries.readingTs',
      key: 'readingTs',
      sortable: true,
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT,
      }
    },
    {
      title: 'meteringPoint.timeSeries.consumption',
      key: 'consumption',
      sortable: true,
      cellRenderer: DecimalCellComponent,
      cellRendererParams: {
        decimals: 3,
      }
    },
    {
      title: 'meteringPoint.timeSeries.readingValue',
      key: 'readingValue',
      sortable: true,
      cellRenderer: DecimalCellComponent,
      cellRendererParams: {
        decimals: 3,
      }
    },
    {
      title: 'meteringPoint.timeSeries.serialNumber',
      key: 'serialNumber',
      sortable: true,
    },
    {
      title: 'meteringPoint.timeSeries.source',
      key: 'source',
      sortable: true,
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        sent: 'common.energyConnect',
        requested: 'common.dataHub'
      }
    },
    { ...consumptiontypePartial, sortable: true } as Columns<AverageQueryMeteredDataResultDto>,
    { ...estimationMethodPartial, sortable: true } as Columns<AverageQueryMeteredDataResultDto>,
    { ...datahubPartial, sortable: true } as Columns<AverageQueryMeteredDataResultDto>,
    {
      title: 'meteringPoint.timeSeries.packageId',
      key: 'packageId',
      sortable: true,
    }
  ]
};
